<template>
  <div>
    <LoadMore
        :on-load-more="onLoadMore"
        :enable-load-more="enableLoadMore"
        :load-more-text="loadMoreText"
    >
      <div class="head_box">
        <div class="header">
          <div class="banner">
            <img src="@/imgs/v2/banner2.png"/>
          </div>
          <div class="head_top">
            <div class="location" @click="$router.push('/position')">
              <img src="@/imgs/v2/positioning.png"/>
              {{ cityName }}
            </div>
            <div class="kefu" @click="$router.push('/server')">
              <img src="@/imgs/v2/customer_service.png"/>
              客服
            </div>
          </div>
        </div>
        <div class="find">
          <!--<p class="p1">当前找店人数<span>{{ count }}</span></p>-->
          <!--<p class="p2">筛选符合我的找店用户</p>-->
          <!--<div class="btn">-->
          <!--立即筛选-->
          <!--<img src="@/imgs/v2/next.png"/>-->
          <!--</div>-->
          <!--<img class="shop" src="@/imgs/v2/shops.png"/>-->
          <div class="num_box">
            <p class="num_p1">{{ count }}</p>
            <p class="num_p2">当前找店人数</p>
          </div>
          <div class="publish_box" @click="toPublish">
            <img src="../imgs/v2/fabu.png"/>
            <p class="find_h2">发布店铺信息</p>
          </div>
          <div class="get_rent" @click="getRent">
            <img src="../imgs/v2/saixuan.png"/>
            <p class="find_h2">筛选找店信息</p>
          </div>
        </div>
      </div>
      <div class="title">
        <div class="title_left">
          <h1 class="active">找店信息</h1>
          <h1 class="shangpu" @click="goToShop">商铺信息</h1>
        </div>
        <p>信息来源于网络</p>
      </div>
      <div ref="list" class="stores">
        <div v-for="(item, index) of rentList" :key="index" class="store">
          <div class="store-title">
            <h1>
              找{{ cityName }}{{ item.title }} {{ envId === 0 ? item.id : '' }}
            </h1>
            <!--<span>官方认证</span>-->
          </div>
          <p class="content">
            {{ item.description || '暂无描述' }}
          </p>
          <div class="store-chat">
            <p>联系人：{{ item.contact || '匿名用户' }}</p>
            <div @click="getPhone(item)">
              <span>联系方式</span>
            </div>
          </div>
        </div>
      </div>
    </LoadMore>
    <van-dialog
        v-model="show"
        :show-cancel-button="false"
        :show-confirm-button="false"
    >
      <div v-if="dialogType === 1" class="dialog">
        <div class="cancel" @click="show = false">
          <img src="@/imgs/more/cancels.png"/>
        </div>
        <h1>提示</h1>
        <p v-if="!hasPay">
          请您先发布信息，<br>
          发布后会把您的信息推广推送给<br>
          适合的找店求租用户
        </p>
        <p class="p2" v-else>
          您的信息已经开始匹配推送，<br>
          保持电话畅通即可
        </p>
        <div @click="hasPay ? (show = false) : $router.push('/publish')">
          {{ hasPay ? '关闭' : '立即发布' }}
        </div>
      </div>

      <div v-if="dialogType === 2" class="dialog2">
        <h1>筛选</h1>
        <van-field
            v-model="cityName"
            label="城市"
            readonly
            class="cell"
            label-class="la-title"
            input-align="right"
            right-icon="arrow"
            placeholder="请选择城市"
            @click="$router.push({ path: '/position', query: { type: 1 } })"
        />
        <van-field
            v-model="tradeName"
            label="行业"
            readonly
            label-class="la-title"
            class="cell"
            input-align="right"
            right-icon="arrow"
            placeholder="请选择行业"
            @click="getTradeList"
        />
        <div class="btns">
          <div class="btn" @click="show = false">取消</div>
          <div class="btn" @click="goToRent">确定</div>
        </div>
      </div>
    </van-dialog>

    <van-popup v-model="showDistrict" close-on-popstate position="bottom">
      <van-picker
          show-toolbar
          :columns="tradeList"
          value-key="tradeName"
          @confirm="onConfirm"
          @cancel="show = false"
      />
    </van-popup>
  </div>
</template>

<script>
import LoadMore from '@/components/LoadMore'
import {getRentList, getTradeList, getUserInfo, getWxLoginUrl, myPublish} from '@/api/api'
import {Dialog} from 'vant'
import {getLocation} from '@/utils/location'
import {citys, headers, RandomNumBoth} from '@/utils/util'

export default {
  name: 'Home',
  components: {
    vanDialog: Dialog.Component,
    LoadMore // 注册mescroll组件
  },
  data() {
    return {
      token: '',
      hasPay: false,
      loadMoreText: '加载中...',
      topToastText: this.$store.getters.config.topToastText,
      homeNumData: {},
      showDistrict: false,
      tradeList: [],
      tradeName: '',
      tradeId: '',
      dialogType: 1, // 1 发布 2选择城市
      count: 0,
      show: false,
      cityName: this.$store.getters.cityName,
      trade: this.$store.getters.trade,
      envId: parseInt(process.env.VUE_APP_SERVER_ID),
      isLook: false,
      rentList: [],
      page: 1,
      size: 10,
      enableLoadMore: true
    }
  },
  async created() {
    let token = this.$store.getters.token
    const {code = ''} = this.$route.query
    console.log(token)
    if (!token) {
      if (!code) {
        const res = await getWxLoginUrl({redirectUri: location.href})
        location.href = res.data
      } else {
        token = await this.$store.dispatch('getLogin', code);
        this.token = token
      }
    }
    // this.userInfo = await officialAccount.getInfo();
    // console.log('userInfo', this.userInfo)
    // if (this.userInfo === undefined || this.userInfo === null) {
    //   console.log('isWechat', $wxsdk.isWechat())
    //   if ($wxsdk.isWechat()) {
    //     location.href = loginUrl(encodeURIComponent(location.href))
    //     this.$store.dispatch('getLogin', code).then(token => {
    //       this.token = token
    //       this.init()
    //     })
    //     const loginRes = await officialAccount.login();
    //     if (loginRes) {
    //       this.userInfo = await officialAccount.getInfo();
    //       await this.$store.dispatch('setUserInfo', this.userInfo);
    //     }
    //     console.log('loginRes', loginRes);
    //   } else {
    //     console.log('非公众号，无需登陆');
    //   }
    // }
  },
  mounted() {
    this.token = this.$store.getters.token
  },
  watch: {
    token(val) {
      if (val) {
        this.getUserInfo()
        this.getConfig()
        this.getLocation()
        if (this.$store.getters.isType2) {
          this.dialogType = 2
          this.show = true
          this.$store.dispatch('setType2', false)
        }
        this.getList()
      }
    }
  },
  methods: {
    goToShop() {
      // this.$dialog.alert({ message: '功能建设中' })
      this.$router.push('/store')
    },
    async getMyPublish() {
      try {
        const form = {
          page: 1,
          limit: 100
        }
        const res = await myPublish(headers(form), form)
        const payList = res.data.filter((s) => {
          return s.publishStatus === '2'
        })
        if (payList.length) {
          this.hasPay = true
        }
      } catch {
        console.log('err')
      }
    },
    async getUserInfo() {
      try {
        const res = await getUserInfo(headers());
        if (res.code === 0) {
          await this.$store.dispatch('setUserInfo', res.data)
        }
        await this.getMyPublish()
      } catch {
        console.log('err')
      }
    },
    async getConfig() {
      const data = await this.$store.dispatch('setConfig')
      console.log(data)
      this.topToastText = data.topToastText
      this.homeNumData = data.homeNumData
    },
    async goToRent() {
      await this.$store.dispatch('setTradeId', this.tradeId)
      this.$router.push('/rent')
    },
    onConfirm(cell) {
      this.showDistrict = false
      this.tradeName = cell.tradeName
      this.tradeId = cell.tradeId
    },
    async getTradeList() {
      const res = await getTradeList()
      this.tradeList = res.data
      this.showDistrict = true
    },
    async getLocation() {
      const that = this
      let count = 0
      let timer = null
      let time = 1
      let speed = 23
      let res
      let city
      if (!this.$store.getters.cityName) {
        res = await getLocation()
        city = res.data.city
        await this.$store.dispatch('setCity', city)
      } else {
        city = this.$store.getters.cityName
      }

      this.cityName = city
      console.log('cityName', city)

      if (citys.includes(city.slice(0, 2))) {
        count = RandomNumBoth(5000, 6000)
      } else {
        count = RandomNumBoth(1000, 2000)
      }
      timer = setInterval(function () {
        that.count += speed
        if (count - that.count < 5 * speed) {
          speed = 1
          time = 100
        }

        if (that.count === count) {
          clearInterval(timer)
        }
      }, time)
    },
    getRent() {
      this.dialogType = 2
      this.show = true
    },
    toPublish() {
      this.$router.push({
        name: 'Publish'
      })
    },
    getPhone(item) {
      if (this.hasPay) {
        this.show = true
        this.dialogType = 1
      } else {
        this.show = true
        this.dialogType = 1
        // const ids =
        //     JSON.parse(localStorage.getItem('lookIds')) !== null
        //         ? JSON.parse(localStorage.getItem('lookIds'))
        //         : []
        // if (ids.length < 2) {
        //     this.tellThis(item, ids)
        // } else {
        //     this.nextRouter(item, ids)
        // }
      }
    },

    tellThis(item, ids) {
      let arr = []
      if (!ids.includes(item.publishId)) {
        arr = [...ids, item.publishId]
        localStorage.setItem('lookIds', JSON.stringify(arr))
      }
      const a = document.createElement('a')
      a.href = `tel:${item.phone}`
      a.style.display = 'none'
      a.click()
    },

    nextRouter(item, ids) {
      if (ids.includes(item.publishId)) {
        const a = document.createElement('a')
        a.href = `tel:${item.phone}`
        a.style.display = 'none'
        a.click()
      } else {
        console.log(this.hasPay)
        this.show = true
        this.dialogType = 1
      }
    },
    onLoadMore(done) {
      if (!this.enableLoadMore) {
        return
      }
      this.page = this.page + 1
      this.getList()
      done()
    },
    getList() {
      const {page, size = 10, cityName} = this
      let rentList = []
      getRentList({page, size, cityName}).then((res) => {
        if (res.data.length === 0) {
          this.loadMoreText = '~ 到底了 ~'
          this.page = page - 1
        } else {
          if (page === 1) {
            rentList = res.data.sort(() => Math.random() - 0.5)
          } else {
            rentList = res.data
          }
          console.log(rentList)
          this.rentList = this.rentList.concat(rentList)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
* {
  -webkit-overflow-scrolling: touch;
}

.main {
  .head_box {
    height: 520px;
  }

  .header {
    width: 100%;
    height: 390px;
    position: relative;
    overflow: hidden;

    .banner {
      width: 100%;
      height: 390px;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;

      img {
        width: 100%;
        height: 100%;
        display: block;
        vertical-align: middle;
      }
    }

    .head_top {
      position: relative;
      z-index: 2;
      height: 100px;
      font-size: 38px;
      justify-content: space-between;
      vertical-align: middle;
      color: #fff;
      display: flex;
      padding: 0 24px;

      .kefu, .location {
        height: 100%;
        display: flex;
        align-items: center;
      }

      img {
        width: 40px;
        height: 40px;
        vertical-align: middle;
        margin-right: 10px;
      }
    }
  }

  .find {
    width: 690px;
    margin: -40px auto;
    border-radius: 8px;
    position: relative;
    height: 170px;
    /*padding-left: 46px;*/
    overflow: hidden;
    background-color: #fff;
    z-index: 10;
    box-shadow: 0 8px 12px #ebedf0;
    display: flex;
    padding-left: 10px;

    .num_box {
      padding-top: 30px;
      width: 218px;
      margin-right: 20px;
      text-align: center;
      position: relative;

      .num_p1 {
        font-size: 42px;
        color: #fd6a42;
        line-height: 64px;
        font-weight: bold;
      }

      .num_p2 {
        font-size: 24px;
        color: #999999;
        line-height: 36px;
        margin-top: 6px;
        font-weight: bold;
      }

      &:after {
        content: "";
        position: absolute;
        right: 0px;
        top: 46px;
        width: 2px;
        height: 80px;
        background-color: #cccccc;
      }
    }

    .find_h2 {
      color: #fd6a42;
      line-height: 42px;
      font-size: 26px;
      text-align: center;
      font-weight: bold;
    }

    .publish_box {
      width: 208px;
      padding-top: 30px;
      /*margin-left: 200px;*/
    }

    .get_rent {
      width: 208px;
      padding-top: 30px;
    }

    img {
      width: 70px;
      height: 70px;
      display: block;
      margin: 0 auto;
    }

    .p1 {
      font-size: 30px;
      margin-top: 22px;
      line-height: 32px;

      span {
        font-size: 32px;
        font-family: PingFang SC;
        font-weight: 800;
        color: #FD6A42;
        margin-left: 30px;
      }
    }

    .p2 {
      font-size: 36px;
      margin-top: 18px;
      color: #fe6b43;
      line-height: 48px;
    }

    .btn {
      width: 240px;
      height: 60px;
      background-color: #ff5b3b;
      color: #fff;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 34px;
      margin-top: 16px;

      img {
        width: 32px;
        height: 32px;
        display: block;
        margin-left: 15px;
      }
    }

    .shop {
      display: block;
      position: absolute;
      width: 181px;
      height: 181px;
      right: 50px;
      top: 34px;
    }
  }

  .btns {
    margin: 0 auto;
    display: flex;
    width: 690px;
    height: 120px;
    display: flex;
    justify-content: space-between;

    .btn {
      display: flex;
      width: 330px;
      height: 120px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 5px 20px 0px rgba(255, 210, 198, 0.2);
      border-radius: 12px;

      .img {
        margin: 25px 11px 29px 11px;
        width: 66px;
        height: 66px;
      }

      div {
        flex: 1;
        height: 100%;
        display: flex;
        flex-direction: column;
        flex-direction: column;
        padding: 29px 0 33px 0;
        justify-content: space-between;

        p {
          font-size: 28px;
          line-height: 28px;
          font-family: PingFang SC;
          font-weight: 800;
          color: rgba(51, 51, 51, 1);
        }

        span {
          font-size: 18px;
          line-height: 18px;
          font-family: PingFang SC;
          font-weight: 500;
          color: rgba(203, 203, 203, 1);
        }
      }
    }
  }

  .title {
    align-items: center;
    padding: 0 30px;
    height: 114px;
    margin-top: 0px;
    display: flex;
    justify-content: space-between;

    .title_left {
      display: flex;
      flex: 1;
    }

    h1 {
      font-size: 30px;
      font-family: PingFang SC;
      font-weight: 800;
      color: #727272;
      font-weight: normal;
    }

    .shangpu {
      margin-left: 40px;
    }

    .active {
      font-size: 32px;
      font-weight: bold;
      color: #333333;
      position: relative;

      &:after {
        position: absolute;
        content: "";
        left: 22px;
        right: 22px;
        bottom: -8px;
        height: 4px;
        background-color: #ff5b3b;
      }
    }

    p {
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(203, 203, 203, 1);
    }
  }

  .stores {
    margin: 0 auto;
    width: 690px;
    display: flex;
    flex-direction: column;

    .store {
      margin-bottom: 30px;
      width: 690px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 5px 25px 0px rgba(255, 209, 197, 0.1);
      border-radius: 12px;
      padding: 29px 30px 21px 30px;
      direction: flex;
      flex-direction: column;

      .store-title {
        width: 100%;
        display: flex;
        align-items: center;

        h1 {
          flex: 1;
          font-size: 32px;
          font-family: PingFang SC;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          line-height: 32px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }

        span {
          margin-left: 19px;
          width: 114px;
          height: 32px;
          line-height: 28px;
          text-align: center;
          background: rgba(255, 241, 237, 1);
          border-radius: 4px;
          font-size: 24px;
          font-family: PingFang SC;
          font-weight: 800;
          color: rgba(255, 106, 74, 1);
        }
      }

      .content {
        margin: 20px 0 17px 0;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(153, 153, 153, 1);
        line-height: 34px;
      }

      .store-chat {
        display: flex;
        justify-content: space-between;
        align-items: center;

        p {
          font-size: 28px;
          font-family: PingFang SC;
          color: rgba(153, 153, 153, 1);
          line-height: 30px;
        }

        div {
          display: flex;
          height: 48px;
          align-items: center;
          /*background: rgba(255, 91, 58, 1);*/
          border-radius: 8px;
          padding: 0 19px;
          color: #ff6b4b;
          border: 2px solid #ff6b4b;

          img {
            margin-right: 13px;
            width: 26px;
            height: 26px;
          }

          span {
            font-size: 26px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #ff6b4b;
          }
        }
      }
    }
  }

  .dialog {
    display: flex;
    flex-direction: column;
    background: rgba(255, 255, 255, 1);
    border-radius: 8px;
    padding: 0 63px 39px 63px;

    .cancel {
      position: absolute;
      width: 60px;
      height: 60px;
      right: 12px;
      top: -50px;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        display: block;
        width: 48px;
        height: 48px;
      }
    }

    h1 {
      font-size: 36px;
      line-height: 120px;
      text-align: center;
      font-family: PingFang SC;
      font-weight: 800;
      color: rgba(51, 51, 51, 1);
    }

    p {
      font-size: 28px;
      white-space: nowrap;
      text-align: center;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      line-height: 36px;
    }

    .p2 {
      font-size: 32px;
    }

    div {
      margin: 62px auto 0 auto;
      width: 300px;
      height: 80px;
      text-align: center;
      line-height: 80px;
      background: rgba(253, 106, 66, 1);
      border-radius: 8px;
      font-size: 32px;
      font-family: PingFang SC;
      font-weight: 800;
      color: rgba(254, 254, 254, 1);
    }
  }

  .dialog2 {
    display: flex;
    flex-direction: column;
    background: rgba(255, 255, 255, 1);
    border-radius: 8px;
    padding: 0 30px 108px 30px;

    h1 {
      margin-bottom: 26px;
      font-size: 36px;
      line-height: 100px;
      text-align: center;
      font-family: PingFang SC;
      font-weight: 800;
      color: rgba(51, 51, 51, 1);
    }

    .btns {
      width: 100%;
      display: flex;
      margin-top: 28px;
      justify-content: space-between;

      .btn {
        width: 240px;
        height: 80px;
        line-height: 80px;
        text-align: center;
        background: rgba(240, 241, 242, 1);
        border-radius: 8px;
        font-size: 32px;
        font-family: PingFang SC;
        font-weight: 800;
        color: rgba(153, 153, 153, 1);
        justify-content: center;

        &:nth-child(2) {
          background: #fd6a42;
          color: #fefefe;
        }
      }
    }

    .cell {
      margin-bottom: 50px;
      width: 100%;
      height: 80px;
      background: rgba(240, 241, 242, 1);
      border-radius: 8px;
    }

    .la-title {
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(102, 102, 102, 1);
    }
  }
}
</style>

<style>
.van-field__control:read-only {
  font-family: PingFang SC;
  font-weight: 800;
  color: rgba(51, 51, 51, 1);
}
</style>
